import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";

export const ActionLista = ({dispatch},payload)=>{
    return serves.folharverpagamentotomador.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',err)
    })
}
export const ActionListaBoletins = ({dispatch},payload)=>{
    return serves.folharverpagamentotomador.boletim(payload).then(res => {
        dispatch('ActionSetBoletins',res)
    }).catch(err => {
        dispatch('ActionSetBoletins',err)
    })
}

export const ActionSetBoletins = ({commit},payload) =>{
    commit(types.SET_BOLETINS,payload)
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
